import { SentryEnvironment } from '@techniek-team/sentry-web';
import {
  EnvironmentApiConfig,
  EnvironmentModel,
} from '@lyceo/homi-dashboard/shared/util-environment';
import { getApiConfig } from '@lyceo/shared/util-environment';

const baseAppUrl: string = 'https://homi-dashboard.kube.techniek-team.nl/';

const apiConfig: EnvironmentApiConfig = {
  homiApiUrl: 'https://api-homi.kube.techniek-team.nl',
  raymondDashboardApiUrl: 'https://dashboard.kube.techniek-team.nl',
};

export const environment: EnvironmentModel = {
  production: false,
  environment: SentryEnvironment.ACCEPTANCE,
  release: '4.0.0-develop.1',
  sentryDsn:
    'https://9cf5445873f86856359cac3e883e9c39@errors.techniek-team.nl/163',
  authConfig: {
    issuer: 'https://login.kube.techniek-team.nl/realms/sso',
    clientId: 'lizzie-homi-dashboard-acceptance',
    responseType: 'code',
    redirectUri: baseAppUrl,
    postLogoutRedirectUri: baseAppUrl,
    scope: 'openid profile email offline_access',
    showDebugInformation: false,
    clearHashAfterLogin: true,
    nonceStateSeparator: 'semicolon',
  },
  ...getApiConfig(apiConfig),
};
